/**
 * Build-time version information.
 * The BUILD_TIMESTAMP is injected at build time via vite.config.js define.
 */

declare const __BUILD_TIMESTAMP__: number;

export const BUILD_TIMESTAMP = __BUILD_TIMESTAMP__;
